/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Civil_Known_Lizard_CryInputs */

const en_civil_known_lizard_cry = /** @type {(inputs: Civil_Known_Lizard_CryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RPnL`)
};

/**
* | output |
* | --- |
* | "RPnL" |
*
* @param {Civil_Known_Lizard_CryInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const civil_known_lizard_cry = /** @type {((inputs?: Civil_Known_Lizard_CryInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Civil_Known_Lizard_CryInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_civil_known_lizard_cry(inputs)
});